export default {
    PRICE: 'PRICE',
    MOVING_AVG_50: 'MOVING_AVG_50',
    MOVING_AVG_200: 'MOVING_AVG_200'
};
